
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/genesys",
      function () {
        return require("private-next-pages/destinations/genesys.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/genesys"])
      });
    }
  